import { POSITION, SIZE, TYPE } from '/@/modules/core/app/constants/tooltip.constants';

export const FormInputTooltipMixin = {
  props: {
    tooltipActive: {
      type: Boolean,
      default: false,
      required: false
    },
    tooltipLabel: {
      type: String,
      default: '',
      required: false
    },
    tooltipPosition: {
      type: String,
      default: POSITION.IS_TOP,
      required: false
    },
    tooltipType: {
      type: String,
      default: TYPE.IS_PRIMARY,
      required: false
    },
    tooltipMultilined: {
      type: Boolean,
      default: false,
      required: false
    },
    tooltipSize: {
      type: String,
      default: SIZE.IS_MEDIUM,
      required: false
    },
    tooltipContentClass: {
      type: String,
      default: '',
      required: false
    },
    tooltipAlways: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
